export const backofficeUrls = {
  error: {
    url: "/error",
    path: "error",
    titleKey: "Error",
  },
  permissionRequired: {
    url: "/permission-required",
    path: "permission-required",
    titleKey: "Permission Required",
  },
  // Backoffice Root
  backoffice: {
    url: "/backoffice",
    path: "backoffice",
    titleKey: "Backoffice",
  },
  search: {
    url: "/backoffice/search-panel",
    path: "search-panel",
    titleKey: "Search panel",
  },
  history: {
    url: "/backoffice/history",
    path: "history",
    titleKey: "History",
  },
  targetBreakdown: {
    url: "/backoffice/target-breakdown",
    path: "target-breakdown",
    titleKey: "Target breakdown",
  },
  informationPanel: {
    url: "/backoffice/information-panel",
    path: "information-panel",
    titleKey: "Information panel",
  },
  backofficeLogin: {
    url: "/backoffice/login",
    path: "backoffice/login",
    titleKey: "Backoffice login",
  },
  // Spring Root
  spring: {
    url: "/spring",
    path: "spring",
    titleKey: "Spring",
  },
  // Debt Settlement
  dscOverview: {
    url: "/spring/debt-settlement/overview",
    path: "debt-settlement/overview",
    titleKey: "Overview",
  },
  dscBulkOperations: {
    url: "/spring/debt-settlement/bulk-operations",
    path: "debt-settlement/bulk-operations",
    titleKey: "Bulk operations",
  },
  anonymousCommunications: {
    url: "/spring/debt-settlement/anonymous-communications",
    path: "debt-settlement/anonymous-communications",
    titleKey: "Anonymous communication",
  },
  representationCompanies: {
    url: "/spring/debt-settlement/representation-companies",
    path: "debt-settlement/representation-companies",
    titleKey: "Representation companies",
  },
  // Partner Operations
  partners: {
    url: "/spring/partners",
    path: "partners",
    titleKey: "Partners",
  },
  addPartner: {
    url: "/spring/partners/add",
    path: "partners/add",
    titleKey: "Add partner",
  },
  editPartner: {
    url: "/spring/partners/:partnerId",
    path: "partners/:partnerId",
    titleKey: "Edit partner",
  },
  paymentsCredentials: {
    url: "/spring/payments-credentials",
    path: "payments-credentials",
    titleKey: "payments credentials",
  },
  sftpManagement: {
    url: "/spring/admin/sftp-management",
    path: "admin/sftp-management",
    titleKey: "SFTP Management",
  },
  addPaymentsCredentials: {
    url: "/spring/payments-credentials/add",
    path: "payments-credentials/add",
    titleKey: "Add Payment Credentials",
  },
  importPricing: {
    url: "/spring/operations/import-pricing",
    path: "operations/import-pricing",
    titleKey: "Import pricing",
  },
  generatePricing: {
    url: "/spring/operations/generate-pricing",
    path: "operations/generate-pricing",
    titleKey: "Generate pricing",
  },
  accountImports: {
    url: "/spring/operations/account-imports",
    path: "operations/account-imports",
    titleKey: "Account Imports",
  },
  accountManagement: {
    url: "/spring/operations/account-management",
    path: "operations/account-management",
    titleKey: "Account Management",
  },
  importPayments: {
    url: "/spring/operations/import-payments",
    path: "operations/import-payments",
    titleKey: "Import payments",
  },
  washing: {
    url: "/spring/operations/washing",
    path: "operations/washing",
    titleKey: "Washing",
  },
  userLevelMedia: {
    url: "/spring/operations/user-level-media",
    path: "operations/user-level-media",
    titleKey: "User level media",
  },
  batchLevelMedia: {
    url: "/spring/operations/batch-level-media",
    path: "operations/batch-level-media",
    titleKey: "Batch level media",
  },
  // Search
  searchSpring: {
    url: "/spring/search",
    path: "search",
    titleKey: "Search",
  },
  informationPanelSpring: {
    url: "/spring/information-panel",
    path: "information-panel",
    titleKey: "Information panel",
  },
  // Call center
  blockedNumbers: {
    url: "/spring/call-center/blocked-numbers",
    path: "call-center/blocked-numbers",
    titleKey: "Blocked numbers",
  },
  rexEmployees: {
    url: "/spring/call-center/rex-employees",
    path: "call-center/rex-employees",
    titleKey: "Employees",
  },
  rexSkillsLegacy: {
    url: "/spring/call-center/rex-skills",
    path: "call-center/rex-skills",
    titleKey: "Employees",
  },
  shiftManagement: {
    url: "/spring/call-center/shift-management",
    path: "call-center/shift-management",
    titleKey: "Shift management",
  },
  simulation: {
    url: "/spring/call-center/simulation",
    path: "call-center/simulation",
    titleKey: "Simulation",
  },
  conversationsSpring: {
    url: "/spring/conversations",
    path: "conversations",
    titleKey: "Conversations",
  },
  // Bankruptcies
  bankruptcies: {
    url: "/spring/bankruptcies",
    path: "bankruptcies",
    titleKey: "Bankruptcies",
  },
  inventory: {
    url: "/spring/inventory",
    path: "inventory",
    titleKey: "Inventory",
  },
  legalCollectionsBulkOperation: {
    url: "/spring/legal-collections/bulk-operation",
    path: "legal-collections/bulk-operation",
    titleKey: "Legal Collections Bulk Operation",
  },
  // Compliance
  disputes: {
    url: "/spring/compliance/disputes",
    path: "compliance/disputes",
    titleKey: "Disputes",
  },
  disputesDashboard: {
    url: "/spring/compliance/overview",
    path: "compliance/overview",
    titleKey: "Overview",
  },
  documentExport: {
    url: "/spring/compliance/document-export",
    path: "compliance/document-export",
    titleKey: "Document export",
  },
  documentRequests: {
    url: "/spring/document-requests",
    path: "document-requests",
    titleKey: "Document requests",
  },
  // Partner Platform
  partnerPlatformReports: {
    url: "/spring/partner-platform/reports",
    path: "partner-platform/reports",
    titleKey: "Reports",
  },
  managePartnerUsers: {
    url: "/spring/partner-platform/manage-partner-users",
    path: "partner-platform/manage-partner-users",
    titleKey: "Manage Partner Users",
  },
  partnerPlatformBulkOperation: {
    url: "/spring/partner-platform/partner-bulk-operations",
    path: "partner-platform/partner-bulk-operations",
    titleKey: "Bulk Operation",
  },
  tasks: {
    url: "/spring/tasks",
    path: "tasks",
    titleKey: "Tasks",
  },
  roles: {
    url: "/spring/admin/roles",
    path: "admin/roles",
    titleKey: "Roles",
  },
  people: {
    url: "/spring/admin/people",
    path: "admin/people",
    titleKey: "People",
  },
  gr4vyValidateLogic: {
    url: "/spring/admin/gr4vy-routing/validate",
    path: "admin/gr4vy-routing/validate",
    titleKey: "Validate Logic",
  },
  recordingPresign: {
    url: "/spring/recordings/presign",
    path: "recordings/presign",
    titleKey: "Recording",
  },
};
